import type { ProductLawApplicability } from '@/shared/hooks/api/product'
import type { RegulationEmptyStateKey } from './types'

export function regulationIsOn(
  applicability: ProductLawApplicability | null
): applicability is ProductLawApplicability & { status: 'APPLICABLE' } {
  return applicability?.status === 'APPLICABLE'
}

export function getRegulationEmptyStateKey(
  applicability: ProductLawApplicability | null
): RegulationEmptyStateKey {
  if (applicability?.status === 'NOT_APPLICABLE') {
    return 'notApplicable'
  }
  if (applicability?.status === 'NEEDS_GRILLING') {
    return 'needsGrilling'
  }
  return 'undecided'
}
